import TitleBar8 from './titleBar8';
export default TitleBar8;
